import { createContext } from "react";

export const SubscribeContext = createContext();